/**
 * Hard caps + timing for the post-help invite share prompt (C3/C4).
 *
 * These bound how often a signed-in user can be nudged to invite someone after
 * a real help exchange. The prompt is deliberately quiet: it never nags, it
 * stops forever once the user shares or dismisses, and it fails CLOSED on any
 * storage error (see src/utils/invitePromptCaps.ts). The state machine that
 * enforces these lives in invitePromptCaps; this module is the single source of
 * truth for the numbers so caps and any UI copy stay in sync.
 *
 * - MIN_MESSAGES_EACH_SIDE: both people must have sent at least this many
 *   messages for the exchange to count as a real, two-sided conversation.
 * - COOLDOWN_DAYS: minimum gap between two prompts for the same user.
 * - LIFETIME_MAX: hard ceiling on prompts ever shown to one user.
 * - OPEN_DELAY_MS: delay before the share sheet opens, so it lands after the
 *   navigation away from the chat instead of flashing over it.
 */
export const INVITE_PROMPTS = {
  MIN_MESSAGES_EACH_SIDE: 1,
  COOLDOWN_DAYS: 14,
  LIFETIME_MAX: 3,
  OPEN_DELAY_MS: 600,
} as const;
